import { Tab, Tabs } from "@blueprintjs/core"
import React, { useState } from "react"
import Parameter from "./Parameter"
import { get } from "lodash-es"
import { withFormController } from "components/Molecules/FormController"
const PARAMETERS = [
  {
    id: "PHYS",
    title: "Physical",
  },
  {
    id: "CHEM",
    title: "Chemical",
  },
  {
    id: "BIOL",
    title: "Biological",
  },
  {
    id: "MCRO",
    title: "Microbial",
  },
  {
    id: "HVYM",
    title: "Heavy Metal",
  },
]
const Parameters = ({ source, path }) => {
  const [selectedTabId, changeSelected] = useState("PHYS")
  const qualityParameters = get(source, path, [])
  return (
    <>
      <h6 className="mt-6 vt-section-header">Parameters</h6>
      <hr className="mt-0" />
      <Tabs
        large={true}
        selectedTabId={selectedTabId}
        className="vt-custom-tabs"
        onChange={tab => changeSelected(tab as string)}
      >
        {PARAMETERS.map(({ id, title }) => (
          <Tab
            key={id}
            id={id}
            title={title}
            panel={
              <Parameter
                path="qualityParameters"
                parameterType={id}
                data={qualityParameters
                  .map((param, index) => ({ ...param, uuid: index }))
                  .filter(params => params.parameterType === id)}
              ></Parameter>
            }
          ></Tab>
        ))}
        <Tabs.Expander />
      </Tabs>
    </>
  )
}

export default withFormController(Parameters)
